import React, { useContext } from 'react';
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { CoordinateContext } from '~/providers/CoordinateProvider';

export const CoordinateDemoContent: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(CoordinateContext);

  if (!context) {
    return (
      <Box sx={{ textAlign: 'center', py: 6 }}>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Navigate to the Coordinate section to use these controls.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/coordinate/patients')}>
          Go to Coordinate
        </Button>
      </Box>
    );
  }

  const { predictIntegrationEnabled, setPredictIntegrationEnabled } = context;

  return (
    <Box sx={{ pt: 1 }}>
      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5, color: 'text.secondary' }}>
        PREDICT INTEGRATION
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Toggle on to simulate a Predict → Coordinate handoff. All patient dispositions become
        locked and a "Via Predict" label appears, showing the integrated product narrative.
      </Typography>

      <Box
        sx={{
          p: 2,
          border: '1px solid',
          borderColor: predictIntegrationEnabled ? 'primary.main' : 'divider',
          borderRadius: 1,
          bgcolor: predictIntegrationEnabled ? 'primary.50' : 'background.paper',
          transition: 'all 0.2s ease',
          mb: 2,
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={predictIntegrationEnabled}
              onChange={e => setPredictIntegrationEnabled(e.target.checked)}
              color="primary"
            />
          }
          label={
            <Box>
              <Typography variant="body2" fontWeight={600}>
                Predict Integration {predictIntegrationEnabled ? 'Enabled' : 'Disabled'}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {predictIntegrationEnabled
                  ? 'Dispositions locked · "Via Predict" label visible on all patients'
                  : 'Coordinate running as standalone product'}
              </Typography>
            </Box>
          }
          sx={{ m: 0, width: '100%', justifyContent: 'space-between', flexDirection: 'row-reverse' }}
        />
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1, color: 'text.secondary' }}>
        NAVIGATION
      </Typography>
      <Stack spacing={1}>
        <Button fullWidth variant="outlined" onClick={() => navigate('/coordinate/patients')}>
          Go to Patient List
        </Button>
        <Button fullWidth variant="outlined" onClick={() => navigate('/coordinate/kpis')}>
          Go to Analytics
        </Button>
      </Stack>
    </Box>
  );
};
